import React from 'react'
import LoginNew from '../components/Login/LoginNew'

export default function LoginPage() {
  return (
    <LoginNew/>
  )
}
